// Initialize countdown
document.addEventListener('DOMContentLoaded', () => {
  const countdownBanners = document.querySelectorAll('.countdown-banner');
  
  countdownBanners.forEach(banner => {
    const countdownDate = banner.dataset.countdownDate;
    const countdownTime = banner.dataset.countdownTime;
    
    const daysElement = banner.querySelector('[data-days]');
    const hoursElement = banner.querySelector('[data-hours]');
    const minutesElement = banner.querySelector('[data-minutes]');
    const secondsElement = banner.querySelector('[data-seconds]');
    
    if (!countdownDate || !countdownTime) {
      console.error('Countdown: Datum oder Uhrzeit fehlt');
      return;
    }

    // Parse target date
    const targetDateTime = `${countdownDate}T${countdownTime}:00`;
    const targetDate = new Date(targetDateTime);

    if (isNaN(targetDate.getTime())) {
      console.error('Countdown: Ungültiges Datum oder Uhrzeit', targetDateTime);
      return;
    }

    console.log('Countdown zielt auf:', targetDate);

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance < 0) {
        updateElement(daysElement, 0);
        updateElement(hoursElement, 0);
        updateElement(minutesElement, 0);
        updateElement(secondsElement, 0);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      updateElement(daysElement, days);
      updateElement(hoursElement, hours);
      updateElement(minutesElement, minutes);
      updateElement(secondsElement, seconds);
    }

    function updateElement(element, value) {
      if (!element) return;
      
      const formattedValue = String(value).padStart(2, '0');
      
      if (element.textContent !== formattedValue) {
        element.textContent = formattedValue;
        element.classList.add('updating');
        setTimeout(() => element.classList.remove('updating'), 300);
      }
    }

    // Start countdown
    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});
